import {initMessageToUserEventListeners} from "@km/components/popups/messageToUserEventListener";
import type {AuswahlProdukt} from "@k/js/product";
import globalsObject from "@k/js/globalsObject";
import type {EventListener} from "@k/global/eventVerteiler";
import {INTERFRAMEMESSAGES} from "@k/global/InterframeMessages";
import {showChangeToNewProductDialog} from "@km/js/showChangeToNewProductDialog";

export const initELs = (e: EventListener, store, i18n) => {
    e.addEventListener(
        [
            INTERFRAMEMESSAGES.WARENKORB_CHANGED,
            INTERFRAMEMESSAGES.REMOVE_ENTWURF_FROM_WARENKORB,
            INTERFRAMEMESSAGES.UPDATE_WARENKORBSYMBOL,
        ],
        () => {
            store.dispatch("loadWarenkorbUebersicht");
            store.dispatch("loadAdressen");
        });
    e.addEventListener("derivedUserDataPathArrivedEvent", data => store.commit("SET_DERIVED_USER_DATAPATH", data))
    e.addEventListener("entwurfBasedOnDeprecatedProductEvent", (data: {
        newProduct: string,
        newAuwiProdukt: string
    }) => {

        if (data.newAuwiProdukt === "") {
            return;
        }
        const newAuswahlProdukt = globalsObject.productController.produkte.getAuswahlProdukte().find(p => p.AuwiProdukt === data.newAuwiProdukt) as AuswahlProdukt | undefined;
        if (newAuswahlProdukt !== undefined) {
            showChangeToNewProductDialog(store, i18n, data.newProduct, newAuswahlProdukt)
        } else {
            const auswahlProdukt = computed(() => globalsObject.productController.produkte.getAuswahlProdukte().find(p => p.AuwiProdukt === data.newAuwiProdukt)) as ComputedRef<AuswahlProdukt>;
            watch(auswahlProdukt,
                (newAuswahlProdukt) => {
                    showChangeToNewProductDialog(store, i18n, data.newProduct, (newAuswahlProdukt))
                },
                {once: true}
            )
        }

    });

    initMessageToUserEventListeners(store, i18n.t);
}